const { defineMessages } = require('@edx/frontend-platform/i18n');

const messages = defineMessages({
  title: {
    id: 'essentials.statsContainer.title',
    defaultMessage: 'Statistics',
    description: 'Container stats title',
  },
  courses: {
    id: 'essentials.statsContainer.courses',
    defaultMessage: 'Courses',
    description: 'Courses string.',
  },
  instructors: {
    id: 'essentials.statsContainer.instructors',
    defaultMessage: 'Instructors',
    description: 'Instructors string.',
  },
  learners: {
    id: 'essentials.statsContainer.learners',
    defaultMessage: 'Learners',
    description: 'Learners string.',
  },
  videos: {
    id: 'essentials.statsContainer.videos',
    defaultMessage: 'Videos',
    description: 'Videos string.',
  },
  courseUnits: {
    id: 'essentials.statsContainer.courseUnits',
    defaultMessage: 'Course Units',
    description: 'Course units string.',
  },
  certificates: {
    id: 'essentials.statsContainer.certificates',
    defaultMessage: 'Certificates',
    description: 'Certificates string.',
  },
});

export default messages;
